export default "__VITE_ASSET__86ff49a4__"